﻿import $ from 'jquery';
import { IRemoteHandler, IRemoteOptions } from "./remote";
import Ajax from "./ajax";

export class SwitchRemoteHandler implements IRemoteHandler {
  public handle($element: JQuery, options: IRemoteOptions): boolean {
    var $input = $element.find('.switch-input');
    var shouldHandle = $element.is('.switch-field');
    if (!shouldHandle)
      return false;

    options.$triggeringEvent?.preventDefault();

    if ($input.isDisabled())
      return true;

    var currentValue = $input.is(':checked');
    var name = $input.attr('name');
    var newValue = !currentValue;
    var data = {}
    data[name] = newValue;

    $input.prop('checked', newValue);

    options.url = options.url || $element.data('url');
    options.data = data;
    options.type = 'post';

    Ajax.execute($element, options);
    return true;
  }
}
